import axios from 'axios';
import trimEnd from 'lodash-es/trimEnd';

/**
 * SettingsService
 */
export default class SettingsService
{
    /**
     * @param name string
     *
     * @returns Promise<PluginsSettings>
     */
    public static async getConfig(name: string = '', filter: string = ''): Promise<PluginSettings[]>
    {
        return (await axios.get<PluginSettings[]>(trimEnd(`admin/cms/settings/${name}`, '/'), {
            params: { filter }
        })).data;
    }
}

export interface PluginSettings
{
    id: string;
    name: string;
}
